import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { VisualizationTabState } from './visualization-tab.model';
import { VisualizationTabStore } from './visualization-tab.store';

@Injectable({ providedIn: 'root' })
export class VisualizationTabStoreQuery extends QueryEntity<VisualizationTabState> {
  constructor(protected store: VisualizationTabStore) {
    super(store);
  }
}
